<template>
  <div v-show="isModalVisible">
    <transition name="slide">
      <div id="groupModal2" class="modal-mask" @click="hide">
        <div class="modal-dialog modal-dialog-slideout modal-lg max-width-container" @click.stop >
          <div class="modal-content p-2">
            <div class="modal-header px-4 pt-2 pb-0">
              <div class="assign-account-wrapper">
                <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                <button type="button" class="close float-right" @click="hide">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="modal-body">
              <div class="modal-body- modal_add_rep d-none- mb-3 marg-left" >

                <b-alert
                  :show="dismissCountDown"
                  dismissible
                  variant="success"
                  @dismissed="dismissCountDown=0"
                  @dismiss-count-down="countDownChanged"
                  >
                  {{ success_message }}
                </b-alert>

          
        <div class="row mb-2 pl-3 pb-2 border-bottom ml-2" v-for="option in 5" v-if="loading == true">
          <div class="col-12 pl-2 pt-2">
            <div class="col-12">
            <PuSkeleton :count="1"></PuSkeleton>
            </div>
            <div class="col-10">
            <PuSkeleton :count="1"></PuSkeleton>
            </div>
          </div>
        </div>

                <div class="row mt-2 mb-3 align-items-end" v-if="loading == false">
                  <div class="col-9">
                    <div class="h4 mb-0">Choose Accounts</div>
                  </div>
                </div>


                <div class="clearfix"></div>
                <div class="col-12 resources_lists pt-2" v-for="(item, aindex) in accounts" :key="aindex">
                    <div class="res_offcanvas_content res_heading_1 text-left">
                    <div class="chkboxwrapper">
                      <div class="custom-control custom-checkbox">
                        <input 
                            type="checkbox" 
                            :name="'account_' + item.id"
                            :id="'account_' + item.id"
                            :value="item.id"
                            v-model="accountsSelected"
                            :checked="item.checked" 
                            @click="getAccountSelected(item, aindex, $event)" 
                            class="custom-control-input">
                        <label class="custom-control-label" :for="'account_' + item.id"></label>
                        {{ item.name }}
                      </div>
                    </div>
                    </div>
                </div>
                    
                <div class="text-center mt-4" v-if="accounts.length > 0 && loading == false">
                    <button type="button" class="btn btn-sm saveBtn" @click="onSubmit()">Save</button>
                </div>
                    

                    <div class="row" v-if="accounts.length == 0 && loading == false">
                      <div class="col">
                        <div>No accounts found.</div>
                      </div>
                    </div>


              </div>

            </div>
            <div class="modal-footer"></div>
          </div>
        </div>
      </div>
    </transition>


      <ActivateModal :isModalVisible="isResourcesConfirmModalVisible" :id="id"  @close="isResourcesConfirmModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">{{ msg }}</div>
        <div slot="body">

        </div>
        <div slot="footer" class="col-3 override-padding">
          <button class="left col-12 btn btn-red" @click="isResourcesConfirmModalVisible = false;">Confirm</button>
        </div>
      </ActivateModal>




  </div>
</template>

<script>
import axios from 'axios';
import router from '../../router/index.js';

import ActivateModal from '../enterpriseadmin/assign_account_pathways_modal.vue';

export default {
  props: ['isModalVisible'],
  data() {
    return {
      accounts: [],
      pathwayId: '',
      apiUrl: '',
      loading: false,
      pathwayName: '',
      accountsSelected: [],
      accountsModified: [],
      accountsRemoved: [],
      msg: '',
      isResourcesConfirmModalVisible: false,
      success_message: '',
      dismissCountDown: 0,
    }
  },
  computed: {
    
  },
    components: {
        ActivateModal,
    },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    hide() {
      this.accountsModified = [];
      this.accountsSelected = [];
      this.accountsRemoved = [];
      this.$emit('closeAssignAccountsListModal');
    },
    getAccountSelected(item, index, event) {
      if(event.target.checked == true) {
         this.accountsSelected.push(event.target.value);
         this.accountsModified.push(event.target.value);
      }
      else {
        if(item.flag == 1) {
          this.msg = item.name + ' has some progress for this pathway!';
          this.isResourcesConfirmModalVisible = true;
          this.accounts[index].checked = true;
          var id = 'account_' + item.id;
          document.getElementById(id).checked = true;
        }
        else {
          const removeItemIndex = this.accountsSelected.indexOf(event.target.value);
          this.accountsRemoved.push(event.target.value);
          if(removeItemIndex > -1) {
            this.accountsSelected.splice(removeItemIndex, 1); 
          }
        }
      }
    },
    onSubmit() {
      axios('/enterprise-admin/assign-account-pathway',
      {
        method: 'POST',
        data: {
          'accountsSelected': this.accountsModified,
          'accountsRemoved': this.accountsRemoved,
          'account_id': this.$store.state.user_accountid,
          'pathway_id': this.pathwayId,
        }
      })
      .then(response => {
        //this.hide();
        this.accountsModified = [];
        this.accountsRemoved = [];
        this.success_message = 'Accounts Pathway updated successfully.';
        this.dismissCountDown = 5;

      })
      .catch(() => {
      });
    },
    getAccounts(pathwayId) {
      this.pathwayId = pathwayId;
      this.accounts = [];
      this.loading = true;
      const params = {};
      params.accountId = this.$store.state.user_accountid;
      params.pathwayId = this.pathwayId;
      axios.get('/desktop/v2/get-enterprise-accounts/pathway-assign', {
        params: params
      })
      .then(response =>  {
        let data = response.data;
        this.loading = false;
        this.accounts = data.accounts;
        this.accountsSelected = data.assigned_accounts;
      })
      .catch(function() {});
    },
  },
  created() {
    this.apiUrl = process.env.API_ENDPOINT;
  },
  mounted() {

  }
}
</script>

<style scoped>
.back_icon { width: 14px; }
.mentee_title_btn {
  background-color: #b3e6fa;
  padding: 2px 10px;
  border-radius: 8px;
  font-size: 12px;
  color: #2d6074;
  border: 0;
  margin-top: -12px;
}
a {
  color: #00ACEE;
}

a:hover,
a:active,
a:focus {
  color: #00ACEE;
}
.progress_step {
  height:10px;
  margin-top: 5px;
}
.panel-title a {
  font-size: 14px;
  color: #002F42 !important;
  font-weight: normal;
  padding-left: 0px;
}

a {
  color: #00ACEE;
}

a:hover,
a:active,
a:focus {
  color: #00ACEE;
}

::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-mask1 {
    position: fixed;
    z-index: 1001;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
@media (min-width: 1200px) {
  .modal-lg {
    width: 690px;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .modal-lg {
    width: 690px;
  }
}
.saveBtn, .saveBtn:focus, .saveBtn:active, .saveBtn:hover {
  color: #FFF !important;
  background: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  width: 100px;
}
.assign-account-wrapper {
    width: 100%;
}
.max-width-container {
    max-width: 100%;
}
.marg-left {
  margin-left: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/assign_account_pathways.vue